import i18n from 'modules/core/lib/i18n'

import locations from 'modules/locations/store/collections/locations'
import teams from 'modules/teams/store/collections/teams'

import { ProcessCategories } from 'modules/processes/domain'

export enum RoleTypes {
  MANAGER = 'manager',
}

export enum AssigneeStrategy {
  MANUAL_SELECTION = 'manual_selection',
  AFFECTED_USER = 'affected_user',
  MANAGER = RoleTypes.MANAGER,
  WORKSPACE = 'locations',
  TEAMS = 'teams',
  TEAM_LEADS = 'team_leads',
}

export const AssigneeTypeSubOptions = {
  [AssigneeStrategy.WORKSPACE]: () =>
    locations.map((location) => ({
      value: +location.attributes.id,
      label: location.attributes.name,
    })),
  [AssigneeStrategy.TEAMS]: (teamIds: number[]) =>
    teams.map((team) => ({
      value: +team.attributes.id,
      label: team.attributes.name,
      selected: teamIds.includes(+team.attributes.id),
    })),
  [AssigneeStrategy.TEAM_LEADS]: (teamIds: number[]) =>
    teams.map((team) => ({
      value: +team.attributes.id,
      label: team.attributes.name,
      selected: teamIds.includes(+team.attributes.id),
    })),
}

const assignedEmployeeLabel = (): Record<ProcessCategories, string> => ({
  custom: i18n.t('processes.process_settings.tasks.form.assigned_employee'),
  offboarding: i18n.t('processes.process_settings.tasks.form.exiting_employee'),
  onboarding: i18n.t('processes.process_settings.tasks.form.new_hire'),
  training: i18n.t('processes.process_settings.tasks.form.course_participant'),
})

export const assigneeSelectionTypes = (category: ProcessCategories) => [
  {
    label: assignedEmployeeLabel()[category],
    value: AssigneeStrategy.AFFECTED_USER,
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.manual_selection'),
    value: AssigneeStrategy.MANUAL_SELECTION,
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.manager'),
    value: AssigneeStrategy.MANAGER,
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.workspace'),
    value: AssigneeStrategy.WORKSPACE,
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.team'),
    value: AssigneeStrategy.TEAMS,
  },
  {
    label: i18n.t('processes.process_settings.tasks.form.team_lead'),
    value: AssigneeStrategy.TEAM_LEADS,
  },
]
